import React, { useContext, useEffect, useState } from 'react';

import LocaleContext from 'contexts/locale-context';

import Button from 'components/button';
import Spacer from 'components/spacer';

import uploader from 'actions/uploader';
import formatSize from 'helpers/format-size';


const getFilesSize = (files = []) => {
  let total = 0;

  files.forEach(file => {
    total += file.file.size;
  });

  return total;
}

const Uploading = ({ files = [], password, onError, onUploaded, onCancel }) => {
  const [transferredBytes, setTransferredBytes] = useState(0);
  const [progress, setProgress] = useState(0);
  const { locale, translations } = useContext(LocaleContext);
  const pageTranslations = translations.index;
  const jsTranslations = translations.js;
  const controller = uploader.getController();

  const totalBytes = getFilesSize(files);

  const _onCancel = async () => {
    if (window.confirm(jsTranslations.are_you_sure)) {
      await controller.stopUpload();

      if (onCancel) onCancel();
    }
  };

  useEffect(function () {
    const body = { language: locale, password };

    if (files.length > 0) {
      controller.reset();

      controller.startUpload(
        {
          body,
          files,
          onProgress: _transferredBytes => {
            setTransferredBytes(_transferredBytes);
            setProgress(
              parseInt((_transferredBytes / totalBytes) * 100)
            )
          }
        }
      )
      .then(({link, transferId}) => {
        setProgress(0);
        if (onUploaded) onUploaded(link, transferId)
      })
      .catch(e => {
        setProgress(0);
        if (onError) onError(e);
      })
    }
  }, [files]);

  return (
    <div className='home__uploading'>
      <div className='home__uploading__progress-container'>
        <p>{progress}%</p>
        <Spacer size='l' />
        <div
          className='home__uploading__progress-line'
        >
          <div style={{ width: `${progress}%` }}></div>
        </div>
      </div>
      <Spacer size='l' />
      <div className='home__uploading__progress-numbers'>
        <p>{formatSize(transferredBytes)}</p>
        <p>{pageTranslations.of}</p>
        <p>{formatSize(totalBytes)}</p>
        <p>{pageTranslations.completed}</p>
      </div>
      <Spacer size='l' />
      <div className='home__uploading__progress-time'>
        <p></p>
      </div>
      <Spacer size='xl' />
      <div className='home__uploading__cancel-button'>
        <Button
          onClick={_onCancel}
          btnType='danger'
          outlined
        >
          {jsTranslations.cancel}
        </Button>
      </div>
    </div>
  );
};

export default Uploading;